import PrivateRoute, { Router } from 'components/app-layout/PrivateRoute';

import OfferFormLayout from './OfferFormLayout';
import OffersGridLayout from './containers/Grid';

export default function OfferLayout() {
  return <Router>
    <PrivateRoute exact path={["/offer/offers", "/offer/offers/add"]} component={OffersGridLayout} />
    <PrivateRoute path="/offer/offers/:id" component={OfferFormLayout} />
  </Router>
}
